module.exports = __webpack_public_path__ + "static/media/children.ab71566a.svg";